module.exports = __webpack_public_path__ + "img/sixpackcarrier34.f82a6d54.jpg";